import React, { useEffect, useState, useMemo } from "react";
import api from "@/lib/api";
import { useSettings } from "@/lib/settings";
import { HeroSection } from "@/components/home/HeroSection";
import {
  FurnitureTypesSection,
  WhyUsSection,
  FeaturedWorksSection,
  ProcessSection,
  TestimonialsSection,
  LatestBlogSection,
  BottomCTASection,
} from "@/components/home/HomeSections";

export default function HomePage() {
  const { settings } = useSettings();
  const [home, setHome] = useState({});
  const [types, setTypes] = useState([]);
  const [projects, setProjects] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [h, t, p, tm, b] = await Promise.all([
        api.get("/home-content").then((r) => r.data).catch(() => ({})),
        api.get("/furniture-types", { params: { active_only: true } }).then((r) => r.data).catch(() => []),
        api.get("/projects", { params: { active_only: true } }).then((r) => r.data).catch(() => []),
        api.get("/testimonials", { params: { active_only: true } }).then((r) => r.data).catch(() => []),
        api.get("/blog", { params: { published_only: true } }).then((r) => r.data).catch(() => []),
      ]);
      if (cancelled) return;
      setHome(h || {});
      setTypes(t || []);
      setProjects(p || []);
      setTestimonials(tm || []);
      setPosts(b || []);
    })();
    return () => { cancelled = true; };
  }, []);

  const whyUs = home.why_us || [];
  const steps = home.process_steps || [];
  const featured = useMemo(() => projects.filter((x) => x.featured).slice(0, 8), [projects]);

  return (
    <div data-testid="home-page">
      <HeroSection home={home} whatsappNumber={settings.whatsapp_number} />
      <FurnitureTypesSection types={types} />
      <WhyUsSection whyUs={whyUs} />
      <FeaturedWorksSection featured={featured} />
      <ProcessSection steps={steps} />
      <TestimonialsSection testimonials={testimonials} />
      <LatestBlogSection posts={posts} />
      <BottomCTASection whatsappNumber={settings.whatsapp_number} />
    </div>
  );
}
